export default __webpack_public_path__ + "static/media/okgo.79cf8571.png";